import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { instance } from '@app/api/axios';

export const fetchWithdrawChannels = createAsyncThunk(
  'withdrawChannels/fetchWithdrawChannels',
  async (_, { rejectWithValue }) => {
    try {
      const res = await instance.get('/teams/crypto_wallets');
      return res.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  },
);

const withdrawChannelsSlice = createSlice({
  name: 'withdrawChannels',
  initialState: {
    withdrawChannels: [],
  },
  extraReducers: (builder) => {
    builder.addCase(fetchWithdrawChannels.fulfilled, (state, action) => {
      state.withdrawChannels = action.payload;
    });
  },
});

export default withdrawChannelsSlice.reducer;
